export { default as batteryImg } from './battery.svg';
export { default as chargerImg } from './charger.svg';
export { default as wallChargerImg } from './wall-charger.svg';
